export default __webpack_public_path__ + "static/media/sninnaker.7ee5098b.svg";